/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getAlertSummary, getAssetUtilization, getUserRequestAPI } from '../../API/RDPMS_API';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import HyperDatepicker from '../../components/Datepicker';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { assetUtilizationColumns, mapRequestDataToOptions, sizePerPageList } from './requestDataMapper';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import PieChartComponent from '../../components/Charts/PieChartComponent';
import BarChartComponent from '../../components/Charts/BarChartComponent';
import GraphChartComponent from '../../components/Charts/GraphChartComponent';
import { equipmentConfig } from '../masterConfig/equipmentConfig';

const AssetUtilization = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));
    const userRole = auth?.user?.role;

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const [selectedViews, setSelectedViews] = useState({ value: 'table', label: 'Table' });

    const [pieData, setPieData] = useState([]);
    const [barData, setBarData] = useState([]);
    const [graphData, setGraphData] = useState([]);

    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const now = new Date();
        const last24Hours = new Date();
        last24Hours.setHours(now.getHours() - 24);
        return last24Hours;
    });

    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedZones, setSelectedZones] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedDivisions, setSelectedDivisions] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedStation, setSelectedStation] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedAssetsType, setSelectedAssetsType] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);
    const [selectedAssetsNumber, setSelectedAssetsNumber] = useState([
        {
            label: 'ALL',
            value: 'all',
        },
    ]);

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [assetsTypeCode, setAssetsTypeCode] = useState([]);
    const [assetsType, setAssetsType] = useState([]);
    const [assetsNumber, setAssetsNumber] = useState([]);

    const [statusMessage, setStatusMessage] = useState('');
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        const fetchStation = async () => {
            await getRequestData(auth.user.id);
        };

        fetchStation();
    }, []);

    useEffect(() => {
        if (stations && stations.length > 0) {
            getAssetUtilizationData(limit, pageNumber);
        }
    }, [stations]);

    const formatDateTime = (date) => {
        if (!date) return {};

        return {
            date: `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(
                2,
                '0'
            )}/${date.getFullYear()}`,
            time: `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
                date.getSeconds()
            ).padStart(2, '0')}`,
        };
    };

    // const getAssetUtilizationData = async (limits, pages) => {
    //     Loading();
    //     // let limitNumber = limits ? limits : limit;
    //     // let pagesNumber = pages ? pages : pageNumber;

    //     let limitNumber = limits ?? limit;
    //     let pagesNumber = pages ?? pageNumber;

    //     const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
    //     const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

    //     const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

    //     const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

    //     // const station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
    //     let station = [];
    //     if (userRole === 'super admin') {
    //         // Existing logic
    //         station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
    //     } else {
    //         //  user station select
    //         if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
    //             station = selectedStation.map((s) => s.value);
    //         } else {
    //             // not select station select  → get stations state
    //             station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
    //         }
    //     }

    //     const assetsType = selectedAssetsType.some((a) => a.value === 'all')
    //         ? []
    //         : selectedAssetsType.map((a) => a.value);

    //     const assetsNumber = selectedAssetsNumber.some((item) => item.value === 'all')
    //         ? []
    //         : selectedAssetsNumber.map((item) => ({
    //               sc: item.sc,
    //               asset_number_code: item.label,
    //           }));

    //     let request = {
    //         start_date: start_date,
    //         start_time: start_time,

    //         end_date: end_date,
    //         end_time: end_time,
    //         request: {
    //             zone: zone,
    //             division: division,
    //             station: station,
    //             asset_type: assetsType,
    //             asset_number: assetsNumber,
    //         },
    //         page_number: pagesNumber,
    //         page_size: limitNumber,
    //     };

    //     let response = await getAssetUtilization(request);
    //     console.log(response, 'response.........');

    //     if (response) {
    //         let srNo = pagesNumber * limitNumber - limitNumber + 1;
    //         let dataArray = [];
    //         const pieMap = {};
    //         const barDataMap = {};
    //         const graphMap = {};

    //         response?.zone?.forEach((z) => {
    //             z.division?.forEach((d) => {
    //                 d.station?.forEach((s) => {
    //                     s.asset_type?.forEach((ast) => {
    //                         const assetTypeName = equipmentConfig[ast.astc]?.assetTypeName || ast.astc || 'Unknown';

    //                         const totalCount = ast.number_of_operations || 0;

    //                         // ONLY asset type
    //                         const key = assetTypeName;

    //                         // PIE
    //                         pieMap[key] = (pieMap[key] || 0) + totalCount;

    //                         // BAR
    //                         barDataMap[key] = (barDataMap[key] || 0) + totalCount;

    //                         // GRAPH (aggregate properly)
    //                         graphMap[key] = (graphMap[key] || 0) + totalCount;

    //                         // direct ast.asnc aur ast.number_of_operations use karenge
    //                         dataArray.push({
    //                             srNo: srNo++,
    //                             zoneCode: z.zc || '',
    //                             divisionCode: d.dc || '',
    //                             stationCode: s.sc || '',

    //                             assetType: ast.astc || '',
    //                             assetNumber: ast.asnc || '',
    //                             numberOfOperations: ast.number_of_operations || 0,
    //                         });
    //                     });
    //                 });
    //             });
    //         });

    //         const pieArray = Object.keys(pieMap).map((key) => ({
    //             name: key,
    //             value: pieMap[key],
    //         }));

    //         const barArray = Object.keys(barDataMap).map((key) => ({
    //             name: key,
    //             total: barDataMap[key],
    //         }));

    //         const graphArray = Object.keys(graphMap).map((key) => ({
    //             name: key,
    //             value: graphMap[key],
    //         }));

    //         // Set states
    //         setPieData(pieArray);
    //         setBarData(barArray);
    //         setGraphData(graphArray);

    //         setPageNumber(response?.pagination?.currentPage);
    //         setPageCount(response?.pagination?.totalPages);
    //         setTotalCount(response?.pagination?.totalCount);

    //         setData(dataArray);

    //         setStatusMessage('Asset utilization fetched successfully');
    //     }
    //     Loading();
    // };

    const getAssetUtilizationData = async (limits, pages) => {
        if (isFetching) return;
        setIsFetching(true);
        Loading();

        let limitNumber = limits ?? limit;
        let pagesNumber = pages ?? pageNumber;

        const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
        const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);
        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        let station = [];
        if (userRole === 'super admin') {
            station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);
        } else {
            if (selectedStation.length > 0 && !selectedStation.some((s) => s.value === 'all')) {
                station = selectedStation.map((s) => s.value);
            } else {
                station = stations.filter((s) => s.value !== 'all').map((s) => s.value);
            }
        }

        const assetsTypeSelected = selectedAssetsType.some((a) => a.value === 'all')
            ? []
            : selectedAssetsType.map((a) => a.value);

        const assetsNumberSelected = selectedAssetsNumber.some((item) => item.value === 'all')
            ? []
            : selectedAssetsNumber.map((item) => ({
                  sc: item.sc,
                  asset_number_code: item.label,
              }));

        let request = {
            start_date,
            start_time,
            end_date,
            end_time,
            request: {
                zone,
                division,
                station,
                asset_type: assetsTypeSelected,
                asset_number: assetsNumberSelected,
            },
            page_number: pagesNumber,
            page_size: limitNumber,
        };

        let response = await getAssetUtilization(request);

        if (response && response.isSuccess !== false) {
            let srNo = pagesNumber * limitNumber - limitNumber + 1;

            // Backend se seedha mapped data — koi nested loop nahi
            const dataArray = (response?.tableRows || []).map((row) => ({
                srNo: srNo++,
                zoneCode: row.zoneCode || '',
                divisionCode: row.divisionCode || '',
                stationCode: row.stationCode || '',
                assetType: row.assetType || '',
                assetNumber: row.assetNumber || '',
                numberOfOperations: row.numberOfOperations || 0,
            }));

            const pieArray = (response?.pieRows || []).map((r) => ({
                name: equipmentConfig[r.assetType]?.assetTypeName || r.assetType || 'Unknown',
                value: r.value,
            }));

            const barArray = (response?.barRows || []).map((r) => ({
                name: equipmentConfig[r.assetType]?.assetTypeName || r.assetType || 'Unknown',
                total: r.total,
            }));

            const graphArray = (response?.graphRows || []).map((r) => ({
                name: equipmentConfig[r.assetType]?.assetTypeName || r.assetType || 'Unknown',
                value: r.value,
            }));

            setPieData(pieArray);
            setBarData(barArray);
            setGraphData(graphArray);

            setPageNumber(response?.pagination?.currentPage || 1);
            setPageCount(response?.pagination?.totalPages || 1);
            setTotalCount(response?.pagination?.totalCount || 0);

            setData(dataArray);

            setStatusMessage(dataArray.length ? 'Asset utilization fetched successfully' : 'No data found');
        } else {
            setData([]);
            setPieData([]);
            setBarData([]);
            setGraphData([]);
            setPageCount(1);
            setTotalCount(0);
            setStatusMessage('Data fetch failed, please try again');
        }
        Loading();
        setIsFetching(false);
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);

            if (response) {
                const { stations, zones, divisions, assetsType, assetsTypeCode, assetsNumber } =
                    mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
                setAssetsType(assetsType);
                setAssetsTypeCode(assetsTypeCode);
                setAssetsNumber(assetsNumber);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAssetUtilizationData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAssetUtilizationData(limit, value);
    };

    const viewOptions = [
        { label: 'Table', value: 'table' },
        { label: 'Pie', value: 'pie' },
        { label: 'Bar', value: 'bar' },
        { label: 'Graph', value: 'graph' },
    ];

    const handleSelectView = async (e) => {
        if (e?.value === 'table') {
            await getAssetUtilizationData(5, 1);
        } else {
            await getAssetUtilizationData(0, 0);
        }

        setSelectedViews(e);
    };

    const downloadAssetsUtilizationExcel = () => {
        const exportData = data.map((row) => ({
            'Sr No': row.srNo,
            'Zone Code': row.zoneCode,
            'Division Code': row.divisionCode,
            'Station Code': row.stationCode,
            'Asset Type': row.assetType,
            'Asset Number': row.assetNumber,
            'Number of Operations': row.numberOfOperations,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Asset Utilization');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });

        saveAs(blob, 'Asset_Utilization.xlsx');
    };

    return (
        <>
            <ToastContainer />
            <div className=" py-3 " style={{ width: '100%' }}>
                {/* <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                       
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Asset Utilization
                            </button>
                        </div>
                    </div>
                </div> */}

                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        <div className="col-12 col-md-auto">
                            <h5
                                className="fw-bold mb-1"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#000',
                                    paddingLeft: '10px',
                                }}>
                                Asset Utilization
                            </h5>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-2 p-1"
                    style={{
                        width: '100%',
                        boxShadow: '0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    {/* sirf container aur spacing update */}
                    <div
                        className="container-fluid"
                        style={{
                            paddingLeft: '10px',
                            paddingRight: '10px',
                        }}>
                        <form>
                            <div className="row d-flex gx-3 gy-2">
                                <div className="col-md-3 form-group">
                                    <label htmlFor="startDate">Start Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-3 form-group">
                                    <label htmlFor="endDate">End Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            defaultValue="2024-08-22"
                                            id="endDate"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => {
                                                setSelectedEndDate(date);
                                            }}
                                        />
                                    </div>
                                </div>

                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Assets Type"
                                    id="assetsSelect"
                                    options={assetsType}
                                    selectedValues={selectedAssetsType}
                                    onChange={setSelectedAssetsType}
                                />

                                <MultiSelectDropdown
                                    label="Assets Number"
                                    id="assetsNumberSelect"
                                    options={assetsNumber}
                                    selectedValues={selectedAssetsNumber}
                                    onChange={setSelectedAssetsNumber}
                                />

                                <MultiSelectDropdown
                                    label="View"
                                    id="viewSelect"
                                    options={viewOptions}
                                    selectedValues={selectedViews}
                                    onChange={(e) => {
                                        handleSelectView(e);
                                    }}
                                    isMulti={false}
                                />
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn"
                                        disabled={isFetching}
                                        onClick={() => getAssetUtilizationData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {(!selectedViews || selectedViews?.value === 'table') && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0  text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <span
                            onClick={downloadAssetsUtilizationExcel}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                border: '1px solid #ccc',
                                padding: '10px 10px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                            <i className="fa fa-download"></i>
                        </span>

                        <Table
                            columns={assetUtilizationColumns}
                            data={data}
                            pageSize={limit}
                            pageCount={pageCount}
                            pageNumber={pageNumber}
                            totalCount={totalCount}
                            sizePerPageList={sizePerPageList}
                            isSortable={true}
                            pagination={true}
                            isSearchable={true}
                            onPageChange={handlePageChange}
                            onPageClick={handlePageClick}
                        />

                        {data?.length === 0 && <div className="text-center py-4 text-muted">No records found</div>}
                    </div>
                )}

                {selectedViews?.value === 'pie' && pieData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <PieChartComponent data={pieData || []} />
                    </div>
                )}

                {selectedViews?.value === 'bar' && barData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <BarChartComponent data={barData || []} />
                    </div>
                )}

                {selectedViews?.value === 'graph' && graphData?.length > 0 && (
                    <div
                        className="col-sm-12 card-alerts my-2 p-2 border-0 text-start no-radius"
                        style={{ width: '100%', position: 'relative' }}>
                        <GraphChartComponent data={graphData || []} />
                    </div>
                )}
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AssetUtilization;
